import gql from 'graphql-tag';

import suggestionFragment from './suggestionFragment';

export const suggestionsPageFragment = gql`
  fragment suggestionsPageFragment on SuggestionsPage {
    dokkioClass
    total
    suggestions {
      ...suggestionFragment
    }
  }
  ${suggestionFragment}
`;
export default suggestionsPageFragment;
